<template>
    <div>
        <el-menu background-color="#DF9894" text-color="#fff" class="el-menu-middle" mode="vertical" router>
            <el-menu-item v-for="(item, index) in menuArr" :key="index" :index="item.path"><span>{{item.name}}</span></el-menu-item>
        </el-menu>
  </div>
</template>

<script>
import router from '../router/index.js';
export default {
  data() {
    return {
      menuArr:[
        {
          name: '首页',
          path: '/'
        },
        {
          name: '大会',
          path: '/conference',
        },
        {
          name: '云展',
          path: '/exhibition',
        },
        {
          name: '活动',
          path: '/active',
        },
        {
          name: '商机',
          path: '/business',
        },
        {
          name: '新闻',
          path: '/news',
        },
        {
          name: '我的',
          path: '/mine',
        },
      ]
    };
  },
  created() {
    localStorage.getItem("languageSet");
  },
  mounted() {
    this.navDefalut();
  },
  computed: {
    getActive:function(){
      var path = this.$router.path.split("/");
      return path;
    },
  },
  methods: {
    navDefalut(){
      this.menuArr.forEach(item => {
          if(item.name == '首页'){
            item.name = this.$t('navMenu.home');
          }else if(item.name == '大会'){
            item.name = this.$t('navMenu.conference');
          }else if(item.name == '云展'){
            item.name = this.$t('navMenu.exhibition');
          }else if(item.name == '活动'){
            item.name = this.$t('navMenu.active');
          }else if(item.name == '商机'){
            item.name = this.$t('navMenu.business');
          }else if(item.name == '新闻'){
            item.name = this.$t('navMenu.news');
          }else if(item.name == '我的'){
            item.name = this.$t('navMenu.mine');
          }
      });
      this.menuArr = this.menuArr;
    }
  }
}
</script>

<style lang="scss" scoped>
// .el-menu{width:100%;height: 100%;}
// .el-menu-item{font-size: 18px;height: 100%;line-height: 25px;flex:1;text-align: center;display: flex;align-items: center;justify-content: center;}
// .el-menu.el-menu--horizontal,.el-menu--horizontal>.el-menu-item{border-bottom: 0 none;}
// .el-menu--horizontal>.el-menu-item.is-active{border-bottom-color: transparent;color: #fff;}
// .el-menu--horizontal > .el-menu-item.is-active{background-color: #CAC28A !important;}
// .el-menu-middle .el-menu-item,.el-menu-middle .el-submenu__title{white-space: normal;}
.el-menu{padding: 0 0.34rem;box-sizing: border-box;}
.el-menu-item{border-bottom: 1px solid #fff;font-size: 0.4rem;line-height:28px;padding: 0.2rem 0;height: auto;}
.el-menu-item:last-child{border-bottom: 0;}
</style>